<div data-spartan-page class="p-6 md:p-8 max-w-screen-2xl mx-auto space-y-6">

  <!-- Page Header -->
  <div class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
    <div>
      <h1 class="text-3xl font-bold tracking-tight">System Monitoring</h1>
      <p class="text-muted-foreground mt-1">
        Real-time health and integration diagnostics for the RARR platform.
      </p>
    </div>

    <div class="flex items-center gap-3 shrink-0">
      <!-- Last refreshed — inline, subtle -->
      <span class="text-xs text-muted-foreground tabular-nums hidden md:inline">
        Updated {{ lastRefreshed() | date:'HH:mm:ss' }}
      </span>
      <!-- Auto-refresh switch -->
      <div class="flex items-center gap-2">
        <label hlmLabel for="auto-refresh" class="text-xs text-muted-foreground cursor-pointer select-none">Auto-refresh</label>
        <hlm-switch
          id="auto-refresh"
          [checked]="autoRefreshEnabled()"
          (checkedChange)="toggleAutoRefresh($event)">
        </hlm-switch>
      </div>
      <!-- Manual refresh button — ghost variant, icon-only -->
      <button hlmBtn variant="ghost" size="icon" (click)="manualRefresh()" aria-label="Refresh now" class="size-9">
        <ng-icon hlm name="lucideRefreshCw" class="size-4" [class.animate-spin]="autoRefreshEnabled()" />
      </button>
    </div>
  </div>

  <!-- Tabs -->
  <hlm-tabs [tab]="activeTab()" (tabActivated)="onTabChange($event)">
    <hlm-tabs-list class="w-fit">
      <button hlmTabsTrigger="health" class="gap-1.5">
        <ng-icon hlm name="lucideHeartPulse" class="size-4" />
        <span>System Health</span>
      </button>
      <button hlmTabsTrigger="integrations" class="gap-1.5">
        <ng-icon hlm name="lucideCloud" class="size-4" />
        <span>Integrations</span>
      </button>
    </hlm-tabs-list>

    <div hlmTabsContent="health" class="mt-4">
      <app-health-tab [autoRefresh]="autoRefreshEnabled()"></app-health-tab>
    </div>

    <div hlmTabsContent="integrations" class="mt-4">
      <app-integrations-tab [autoRefresh]="autoRefreshEnabled()"></app-integrations-tab>
    </div>
  </hlm-tabs>
</div>
